import {lazy, useEffect} from "react";
import IntroContent from "../../content/IntroContent.json";
import {Analytics, logEvent} from "firebase/analytics";
const Container = lazy(() => import("../../common/Container"));
const ScrollToTop = lazy(() => import("../../common/ScrollToTop"));
const ContentBlock = lazy(() => import("../../components/ContentBlock"));

const Home = (props: { fireAnalytics: Analytics; }) => {
    useEffect(() => {
        console.log("home")
        logEvent(props.fireAnalytics, "home");
    });
  return (
    <Container>
      <ScrollToTop />
      <ContentBlock
        type="start"
        title={IntroContent.title}
        content={IntroContent.text}
        button={IntroContent.button}
        icon="developer.svg"
        id="intro"
        fireAnalytics={props.fireAnalytics}
      />
    </Container>
  );
};

export default Home;
